<template>
   	<div class="rankBg">
   		<div class="ulGroup">
	   		<ul>
	   			<li url="singer/list/88" @click="goSingerList($event)">热门歌手</li>
	   		</ul>
	   		<ul>
	   			<li url="singer/list/1" @click="goSingerList($event)">华语男歌手</li>
	   			<li url="singer/list/2" @click="goSingerList($event)">华语女歌手</li>
	   			<li url="singer/list/3" @click="goSingerList($event)">华语组合</li>
	   		</ul>
	   		<ul>
	   			<li url="singer/list/4" @click="goSingerList($event)">日韩男歌手</li>
	   			<li url="singer/list/5" @click="goSingerList($event)">日韩女歌手</li>
	   			<li url="singer/list/6" @click="goSingerList($event)">日韩组合</li>
	   		</ul>
	   		<ul>
	   			<li url="singer/list/7" @click="goSingerList($event)">欧美男歌手</li>
	   			<li url="singer/list/8" @click="goSingerList($event)">欧美女歌手</li>
	   			<li url="singer/list/9" @click="goSingerList($event)">欧美组合</li>
	   		</ul>
   		</div>
	</div>	
</template>

<script>
  export default {
    data () {
      return {
		url:'',
      }
    },
    computed: {
    	
    },
    components:{

  	},
  	mounted:function(){

    },
    methods: {
      goSingerList:function(e){
      	this.$store.commit('setGuodu',true);
		var url=e.target.attributes.url.value;
		var _this=this;
		$.ajax({ 
			type:"get",
			url: "https://www.xi-g.com/api/agent_api/newSongList?url="+url,
			success: function(data){
				var div = document.createElement('div');
				div.innerHTML = data;
				var list = div.querySelectorAll('.singer-img-list li');
				var singerList = [];
				for(var i=0;i<list.length;i++){
					var singer={};
					singer.name=list[i].querySelector('.panel-img-content-first').textContent;
					singer.imgUrl=list[i].querySelector('.panel-img-left img').getAttribute('_src');
					singer.location="singer/info/"+list[i].querySelector('a').href.substr(31);
					singerList.push(singer);
				}
				var pageTitle=div.querySelector('.page-title').textContent;
				_this.$store.commit('rankTime',pageTitle);
				_this.$store.commit('singerList',singerList);
				_this.$store.commit('setGuodu',false);
				_this.$router.push('/singer_list');
			},
			error:function(){
				alert(-1)
			}
		});
      }
    }
  }
</script>

<style scoped>
.rankBg{background: url(../../dist/bg01.jpg);width: 100%;height: 100%;background-size: 15%;}
.ulGroup{width: 100%;position: absolute;top:18%;left:0;background: url(../../dist/bg01.jpg);background-size: 15%;}
.ulGroup ul{width: 90%;margin: 12px auto;border: 1px solid #444;border-radius: 5px;overflow: hidden;box-shadow: 0px 0px 12px rgba(255,255,255,0.2) inset;}
.ulGroup ul li{padding: 9px 20px;font-size: 15px;color: #ccc;border-bottom: 1px solid #444;background: rgba(255,255,255,0.03) url(../assets/images/arrow_icon.png) no-repeat 95% center;background-size: 2.5%;}
.ulGroup ul li:last-child{border: none;}
</style>


// WEBPACK FOOTER //
// singer.vue?998f467c